import { ApiClientBase } from '../base/api-client-base.ts';
import Endpoints from '../endpoints';
import type {
  IPaymentsApi,
  SubscriptionResponse,
  CreateOrderParams,
  CreateOrderResponse,
  QuoteOrderParams,
  CheckoutQuote,
  RevolutOrderData,
  DetectedPricing,
  AccountResponse,
  MutationResult,
  CardSetupOrder,
  CardSetupOrderResponse,
} from '@/services/api';

export class PaymentsApi extends ApiClientBase implements IPaymentsApi {
  public readonly getSubscription = async (
    userId: string
  ): Promise<SubscriptionResponse> => {
    const url = Endpoints.Payments.getSubscription(userId);
    const response = await this.asyncRunner(() =>
      this.api.get<SubscriptionResponse>(url)
    );
    return response.data;
  };

  public readonly createOrder = async (
    params: CreateOrderParams
  ): Promise<RevolutOrderData> => {
    const url = Endpoints.Payments.createOrder();
    const response = await this.asyncRunner(() =>
      this.api.post<CreateOrderResponse>(url, params)
    );
    return response.data.data;
  };

  public readonly quoteOrder = async (params: QuoteOrderParams): Promise<CheckoutQuote> => {
    const url = Endpoints.Payments.quoteOrder();
    const response = await this.asyncRunner(() =>
      this.api.post<{ success: boolean; data: CheckoutQuote }>(url, params)
    );
    return response.data.data;
  };

  public readonly detectCurrency = async (): Promise<DetectedPricing> => {
    const url = Endpoints.Payments.detectCurrency();
    const response = await this.asyncRunner(() =>
      this.api.get<DetectedPricing>(url)
    );
    return response.data;
  };

  public readonly getAccount = async (): Promise<AccountResponse> => {
    const url = Endpoints.Account.get();
    const response = await this.asyncRunner(() =>
      this.api.get<AccountResponse>(url)
    );
    return response.data;
  };

  public readonly cancelSubscription = async (): Promise<MutationResult> => {
    const url = Endpoints.Account.cancelSubscription();
    const response = await this.asyncRunner(() =>
      this.api.post<MutationResult>(url)
    );
    return response.data;
  };

  public readonly resumeSubscription = async (): Promise<MutationResult> => {
    const url = Endpoints.Account.resumeSubscription();
    const response = await this.asyncRunner(() =>
      this.api.post<MutationResult>(url)
    );
    return response.data;
  };

  public readonly setupCardOrder = async (): Promise<CardSetupOrder> => {
    const url = Endpoints.Account.setupCardOrder();
    const response = await this.asyncRunner(() =>
      this.api.post<CardSetupOrderResponse>(url)
    );
    return response.data.data;
  };

  public readonly finalizeCardSetup = async (orderId: string): Promise<MutationResult> => {
    const url = Endpoints.Account.finalizeCardSetup();
    const response = await this.asyncRunner(() =>
      this.api.post<MutationResult>(url, { orderId })
    );
    return response.data;
  };
}
